<template>
  <v-dialog v-model="show" scrollable max-width="600px" :fullscreen="isMobile">
    <v-card>
      <v-card-title style="justify-content: center">{{ $t('components.modalPosition.selectPosition') }}</v-card-title>
      <v-card-text>
        <v-col v-if="!displayedLocations">
          <v-row justify="center">
            <v-progress-circular indeterminate></v-progress-circular>
          </v-row>
        </v-col>
        <v-radio-group
          v-else-if="Array.isArray(displayedLocations) && displayedLocations.length"
          v-model="pickedLocation"
          hide-details
        >
          <v-radio v-for="location in displayedLocations" :key="location.location_id" :value="location.location_id">
            <template v-slot:label>
              <v-row>
                <v-col cols="7">
                  <span class="text-caption text-sm-subtitle-2">{{ location.location_id }} - {{ location.name }}</span>
                </v-col>
                <v-col class="text-right" cols="5" v-if="location.availabilityText">
                  <span
                    class="text-caption text-sm-subtitle-2 text-lowercase"
                    :style="'color: ' + location.availabilityTextColor"
                  >
                    {{ location.availabilityText }}
                  </span>
                </v-col>
              </v-row>
            </template>
          </v-radio>
        </v-radio-group>
        <v-col v-else>
          <v-row justify="center">
            {{ $t('components.modalReassignPreparation.noLocationFound') }}
          </v-row>
        </v-col>
      </v-card-text>
      <v-col v-if="pickedLocation && pickupLocation && !pickupServiceActivated">
        <span>
          <v-card-text class="red--text pb-0 pt-0 text-center">
            {{
              $t('components.modalReassignPreparation.serviceNotActiveAtPickupLocation', {
                serviceName: getServiceName(),
                pickupLocationName: `${pickupLocation.location_id} - ${pickupLocation.name}`,
              })
            }}
          </v-card-text>
          <v-checkbox
            v-model="forceAllocation"
            :label="$t('components.modalReassignPreparation.forceAllocation')"
            class='mt-0'
            hide-details
          ></v-checkbox>
        </span>
      </v-col>
      <v-card-actions class="pa-0">
        <v-btn color="primary" tile style="width: 50%" :disabled="disableConfirmedButton" @click="confirm()">
          {{ $t('subOrder.confirm') }}
        </v-btn>
        <v-btn color="secondary" tile class="ml-0" style="width: 50%" @click="close()">
          {{ $t('subOrder.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { EventBus } from '../../event-bus'

  export default {
    name: 'pickLocationDialog',
    data() {
      return {
        displayedLocations: undefined,
        pickedLocation: undefined,
        loadingLocations: false,
        pickupLocation: undefined,
        forceAllocation: false,
      }
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      choices: {
        type: Array,
        required: false,
      },
      orderForManualAllocation: {
        type: Object,
        required: false,
      },
      pickupLocationId: {
        type: String,
      },
    },
    computed: {
      show: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
      isMobile() {
        return this.$vuetify.breakpoint.width < 650
      },
      pickupServiceActivated() {
        if (this.pickupLocation?.services) {
          if (this.pickedLocation === this.pickupLocation.location_id) {
            return this.pickupLocation.services.click_and_collect
          } else {
            return this.pickupLocation.services.delivery_in_store
          }
        }
        return true
      },
      disableConfirmedButton() {
        if (this.pickedLocation === undefined) {
          return true
        } else if (this.pickupLocation && !this.pickupServiceActivated) {
          return !this.forceAllocation
        } else {
          return false
        }
      },
    },
    watch: {
      show: function (val) {
        if (val == true) {
          if (this.choices) {
            this.displayedLocations = this.choices
          } else if (!this.displayedLocations) {
            this.getValidLocations()
          }
          if (this.pickupLocationId) {
            this.getPickupLocation()
          }
        }
      },
    },
    methods: {
      confirm() {
        this.$emit('confirm', this.pickedLocation)
        this.show = false
      },
      close() {
        this.$emit('close')
        this.show = false
      },
      async getValidLocations() {
        let myInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          queryStringParameters: {
            itemsPerPage: false,
            fields: ['location_id', 'name', 'services', 'type'],
          },
        }
        this.$Amplify.API.get('locations', '/v1/int/locations', myInit)
          .then((fetchedLocations) => {
            if (this.orderForManualAllocation) {
              let locations = this.filterLocationsByServices(fetchedLocations.data)
              this.sortLocationsByAvailability(locations)
            } else {
              this.displayedLocations = fetchedLocations.data
            }
          })
          .catch((e) => {
            console.log(e)
            EventBus.$emit('displaySnackbar', {
              display: true,
              text: this.$t('orderWorkflow.locationsLoadingErrorMessage'),
              color: 'error',
            })
          })
      },
      checkStoreRequiredService(subOrder, location) {
        if (location.services) {
          if (subOrder.pickup_location_id === location.location_id) {
            return location.services.click_and_collect === true
          } else {
            return location.services.ship_from_store === true
          }
        } else {
          return false
        }
      },
      async sortLocationsByAvailability(displayedLocations) {
        let productRefs = []
        this.orderForManualAllocation.items.forEach((item) => {
          if (item.product_id) {
            productRefs.push(item.product_id)
          }
        })
        const locationIds = displayedLocations.map((displayedLocation) => displayedLocation.location_id)
        const unifiedStockInit = {
          headers: {
            Authorization: 'Bearer ' + this.$auth.accessToken,
          },
          queryStringParameters: {
            per_page: 10000,
            product_id: productRefs,
            location_id: locationIds,
          },
        }
        this.$Amplify.API.get('stocks', '/stocks', unifiedStockInit)
          .then((res) => {
            displayedLocations = displayedLocations.map((location) => {
              let availabilityText = {
                availabilityText: this.$t('components.modalReassignPreparation.unavailable'),
                availabilityTextColor: '#F6351D',
                availabilityValue: 'unavailable',
              }
              if (this.checkItemsAvailability(location, res.data)) {
                availabilityText = {
                  availabilityText: this.$t('components.modalReassignPreparation.available'),
                  availabilityTextColor: '#63AF60',
                  availabilityValue: 'available',
                }
              }
              return { ...location, ...availabilityText }
            })
            this.displayedLocations = displayedLocations.sort(function (a, b) {
              return getSortFunction(a, b, ['availability', 'locationType'])
            })
          })
          .catch((e) => {
            console.log(e)
          })
      },
      filterLocationsByServices(locations) {
        return locations.filter(
          (location) =>
            location.type === 'warehouse' || this.checkStoreRequiredService(this.orderForManualAllocation, location)
        )
      },
      checkItemsAvailability(location, stocks) {
        for (let item of this.orderForManualAllocation.items) {
          const stockLine = stocks.find(
            (stock) => stock.location_id === location.location_id && stock.product_id === item.product_id
          )
          const quantityToCheck = item.validated_quantity ?? item.product_quantity
          if (!stockLine || stockLine.stock_available < quantityToCheck) {
            return false
          } else {
            //to handle check on splitted lines
            stockLine.stock_available -= quantityToCheck
          }
        }
        return true
      },
      getServiceName() {
        if (this.pickedLocation === this.orderForManualAllocation.pickup_location_id) {
          return this.$t('components.modalReassignPreparation.clickAndCollect')
        }
        return this.$t('components.modalReassignPreparation.inStorePickup')
      },
      async getPickupLocation() {
        if (this.pickupLocationId) {
          let myInit = {
            headers: {
              Authorization: 'Bearer ' + this.$auth.accessToken,
            },
            queryStringParameters: {
              fields: ['location_id', 'name', 'services'],
            },
          }
          this.$Amplify.API.get('locations', '/v1/int/locations/' + this.pickupLocationId, myInit)
            .then((location) => {
              this.pickupLocation = location
            })
            .catch((e) => {
              console.log(e)
              EventBus.$emit('displaySnackbar', {
                display: true,
                text: this.$t('orderWorkflow.locationsLoadingErrorMessage'),
                color: 'error',
              })
            })
        }
      },
    },
  }
  function getSortFunction(a, b, sortTypes) {
    let sortTypesIteration = sortTypes ? JSON.parse(JSON.stringify(sortTypes)) : []
    let sortType
    let comparison = 1
    let isLastSort = !(Array.isArray(sortTypesIteration) && sortTypesIteration.length)

    if (!isLastSort) {
      sortType = sortTypesIteration.shift()
    }
    switch (sortType) {
      case 'availability':
        if (a.availabilityValue === 'available' && b.availabilityValue === 'unavailable') {
          comparison = -1
        } else if (a.availabilityValue === 'unavailable' && b.availabilityValue === 'available') {
          comparison = 1
        } else {
          comparison = 0
        }
        break
      case 'locationType':
        if (a.type === 'warehouse' && b.type === 'shop') {
          comparison = -1
        } else if (a.type === 'shop' && b.type === 'warehouse') {
          comparison = 1
        } else {
          comparison = 0
        }
        break
      default:
        comparison = a.name > b.name ? 1 : -1
        break
    }
    /*
     * if we got an equality applying the current criteria and we still have a next criteria available we apply it,
     * else we return the current comparison value
     */
    return comparison != 0 || isLastSort ? comparison : getSortFunction(a, b, sortTypesIteration)
  }
</script>
<style scoped>
  .w-45 {
    width: 45%;
  }
</style>
